export default __webpack_public_path__ + "static/O0245-ebb6228d21716e201daf5e1354ea5095.png";